import $ from 'jquery';

$(function () {
    if ($('#my_site_page').length) {
        $('#bio-less').css('display', 'block');
        $('#bio-more').css('display', 'none');
        $('#edu-less').css('display', 'block');
        $('#edu-more').css('display', 'none');
        $('#ex-less').css('display', 'block');
        $('#ex-more').css('display', 'none');
        $('#p-less').css('display', 'block');
        $('#p-more').css('display', 'none');
        $('#pq-less').css('display', 'block');
        $('#pq-more').css('display', 'none');
        $('#interest-less').css('display', 'block');
        $('#interest-more').css('display', 'none');

        $('#bio-more-link').click(function () {
            $('#bio-more').css('display', 'block');
            $('#bio-more-link').css('display', 'none');
            $('#bio-less').css('display', 'none');
        });
        $('#edu-more-link').click(function () {
            $('#edu-more').css('display', 'block');
            $('#edu-more-link').css('display', 'none');
            $('#edu-less').css('display', 'none');
        });
        $('#ex-more-link').click(function () {
            $('#ex-more').css('display', 'block');
            $('#ex-more-link').css('display', 'none');
            $('#ex-less').css('display', 'none');
        });
        $('#p-more-link').click(function () {
            $('#p-more').css('display', 'block');
            $('#p-more-link').css('display', 'none');
            $('#p-less').css('display', 'none');
        });
        $('#pq-more-link').click(function () {
            $('#pq-more').css('display', 'block');
            $('#pq-more-link').css('display', 'none');
            $('#pq-less').css('display', 'none');
        });
        $('#interest-more-link').click(function () {
            $('#interest-more').css('display', 'block');
            $('#interest-more-link').css('display', 'none');
            $('#interest-less').css('display', 'none');
        });
    }
});